export default () => 'Conjugarden – Conjugr8'
